import React, { useEffect, type RefObject } from 'react'

export function useEcosystemFilterPanelDismiss(
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>,
  filterBarRef: RefObject<HTMLDivElement | null> | undefined,
  componentRef: RefObject<HTMLDivElement | null>
): boolean {
  const alignToBarRight = filterBarRef != null

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      const target = event.target as Node
      const isInsideDropdown = componentRef.current !== null && componentRef.current.contains(target)
      const isInsideBar = alignToBarRight && filterBarRef?.current != null && filterBarRef.current.contains(target)
      if (!isInsideDropdown && !isInsideBar) {
        setExpanded(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [setExpanded, alignToBarRight, filterBarRef])

  return alignToBarRight
}
